<template>
  <div class="discount-dialog">
    <el-dialog
      title="保费打折"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose">
      <el-form :model="formData" :rules="rules" ref="discountForm" label-width="120px" v-loading="loading">
        <el-form-item label="订单ID：">
          <span>{{ formData.id }}</span>
        </el-form-item>
        
        <el-form-item label="原保费(元)：">
          <span>{{ originalPrice }}</span>
        </el-form-item>
        
        <el-form-item label="折扣率：" prop="discount">
          <el-input-number
            v-model="formData.discount"
            :min="0"
            :max="100"
            :step="1"
            controls-position="right"
            style="width: 120px;">
          </el-input-number>
          <span style="margin-left: 10px;">%</span>
        </el-form-item>
        
        <el-form-item label="折后保费(元)：">
          <span style="color: #ff7300; font-weight: bold;">{{ discountedPrice }}</span>
        </el-form-item>
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { ygbOrderDiscount } from '@/api/member.js'
import { formatMoney } from '@/utils/formatter'

export default {
  name: 'Discount',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      loading: false,
      submitLoading: false,
      formData: {
        id: '',
        discount: 100
      },
      rules: {
        discount: [
          { required: true, message: '请输入折扣率', trigger: 'blur' }
        ]
      },
      originalPrice: '0.00'
    }
  },
  computed: {
    discountedPrice() {
      if (this.formData.discount && this.originalPrice) {
        const original = parseFloat(this.originalPrice.replace(/,/g, ''))
        if (!isNaN(original)) {
          const discounted = original * (this.formData.discount / 100)
          return formatMoney(discounted * 100, '') // 转换为分
        }
      }
      return '0.00'
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.initFormData()
      }
    }
  },
  methods: {
    initFormData() {
      if (this.rowData && Object.keys(this.rowData).length > 0) {
        this.formData = {
          id: this.rowData.id,
          discount: 100
        }
        // 获取原保费，这里假设actual_price是实际保费（单位：分）
        this.originalPrice = formatMoney(this.rowData.actual_price, '')
      }
    },
    handleClose() {
      this.dialogVisible = false
      this.$emit('update:visible', false)
      this.$refs.discountForm.resetFields()
    },
    handleSubmit() {
      this.$refs.discountForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          const params = {
            id: this.formData.id,
            discount: this.formData.discount
          }
          
          ygbOrderDiscount(params).then(response => {
            if (response && response.err_code === 0) {
              this.$message.success('保费打折设置成功')
              this.$emit('success')
              this.handleClose()
            } else {
              this.$message.error(response.err_msg || '设置失败')
            }
            this.submitLoading = false
          }).catch(error => {
            console.error('设置失败:', error)
            this.$message.error('设置失败: ' + (error.message || '未知错误'))
            this.submitLoading = false
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.discount-dialog {
  /deep/ .el-dialog__body {
    padding: 20px;
  }
  
  .el-form-item {
    margin-bottom: 20px;
  }
}
</style>